const _physicianPortalSurveyQuestionId = Symbol();
const _surveyQuestionLayoutId = Symbol();
const _name = Symbol();
const _appearanceFromStart = Symbol();
const _appearanceOffSetDays = Symbol();
const _appearanceIntervalDays = Symbol();
const _sortOrder = Symbol();
const _answeredThresholdTrigger = Symbol();

const coalesce = (...args) => args.find(v => v !== undefined);

export class PhysicianPortalSurveyQuestion {
	constructor(physicianPortalSurveyQuestionId, surveyQuestionLayoutId, name, appearanceFromStart, appearanceOffsetDays, appearanceIntervalDays, sortOrder, answeredThresholdTrigger) {
		this.physicianPortalSurveyQuestionId = physicianPortalSurveyQuestionId;
		this.surveyQuestionLayoutId = surveyQuestionLayoutId;
		this.name = name;
		this.appearanceFromStart = appearanceFromStart;
		this.appearanceOffsetDays = appearanceOffsetDays;
		this.appearanceIntervalDays = appearanceIntervalDays;
		this.sortOrder = sortOrder;
		this.answeredThresholdTrigger = answeredThresholdTrigger;
	}
	get physicianPortalSurveyQuestionId() {
		return this[_physicianPortalSurveyQuestionId];
	}
	set physicianPortalSurveyQuestionId(v) {
		if(!Number.isInteger(v))
			throw new TypeError('physicianPortalSurveyQuestionId must be an integer.');
		this[_physicianPortalSurveyQuestionId] = v;
	}
	get surveyQuestionLayoutId() {
		return this[_surveyQuestionLayoutId];
	}
	set surveyQuestionLayoutId(v) {
		if(!Number.isInteger(v))
			throw new TypeError('surveyQuestionLayoutId must be an integer.');
		this[_surveyQuestionLayoutId] = v;
	}
	get name() {
		return this[_name];
	}
	set name(v) {
		if(typeof v !== 'string')
			throw new TypeError('name must be a string.');
		this[_name] = v;
	}
	get appearanceFromStart() {
		return this[_appearanceFromStart];
	}
	set appearanceFromStart(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('appearanceFromStart must be a boolean.');
		this[_appearanceFromStart] = v;
	}
	get appearanceOffsetDays() {
		return this[_appearanceOffSetDays];
	}
	set appearanceOffsetDays(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('appearanceOffsetDays must be an integer.');
		this[_appearanceOffSetDays] = v;
	}
	get appearanceIntervalDays() {
		return this[_appearanceIntervalDays];
	}
	set appearanceIntervalDays(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('appearanceIntervalDays must be an integer.');
		this[_appearanceIntervalDays] = v;
	}
	get sortOrder() {
		return this[_sortOrder];
	}
	set sortOrder(v) {
		if(!Number.isInteger(v))
			throw new TypeError('sortOrder must be an integer.');
		this[_sortOrder] = v;
	}
	get answeredThresholdTrigger() {
		return this[_answeredThresholdTrigger];
	}
	set answeredThresholdTrigger(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('answeredThresholdTrigger must be an integer.');
		this[_answeredThresholdTrigger] = v;
	}
	toJSON() {
		return {
			physicianPortalSurveyQuestionId: this.physicianPortalSurveyQuestionId,
			surveyQuestionLayoutId: this.surveyQuestionLayoutId,
			name: this.name,
			appearanceFromStart: this.appearanceFromStart,
			appearanceOffsetDays: this.appearanceOffsetDays,
			appearanceIntervalDays: this.appearanceIntervalDays,
			sortOrder: this.sortOrder,
			answeredThresholdTrigger: this.answeredThresholdTrigger
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			coalesce(obj.physicianPortalSurveyQuestionId, obj.PhysicianPortalSurveyQuestionId, null),
			coalesce(obj.surveyQuestionLayoutId, obj.SurveyQuestionLayoutId, null),
			coalesce(obj.name, obj.Name, null),
			coalesce(obj.appearanceFromStart, obj.AppearanceFromStart, null),
			coalesce(obj.appearanceOffsetDays, obj.AppearanceOffsetDays, null),
			coalesce(obj.appearanceIntervalDays, obj.AppearanceIntervalDays, null),
			coalesce(obj.sortOrder, obj.SortOrder, null),
			coalesce(obj.answeredThresholdTrigger, obj.AnsweredThresholdTrigger, null)
		);
	}
}